<template lang="pug">
    article#ead40
        Header
        Banner
        NovosTempos
        Educacao
        Indicado
        GradeCurricular
        Certificado
        Metodologia
        //- Inscricao
</template>

<script>
import Header from '@sections/Ead40/Header/Header.vue'
import Banner from '@sections/Ead40/Banner/Banner.vue'
import NovosTempos from '@sections/Ead40/NovosTempos/NovosTempos.vue'
import Educacao from '@sections/Ead40/Educacao/Educacao.vue'
import Indicado from '@sections/Ead40/Indicado/Indicado.vue'
import GradeCurricular from '@sections/Ead40/GradeCurricular/GradeCurricular.vue'
import Certificado from '@sections/Ead40/Certificado/Certificado.vue'
import Metodologia from '@sections/Ead40/Metodologia/Metodologia.vue'
import Inscricao from '@components/Inscricao/Inscricao.vue'

export default {
    name: "view-ead-40",
    components: {
        Header,
        Banner,
        NovosTempos,
        Educacao,
        Indicado,
        GradeCurricular,
        Certificado,
        Metodologia,
        Inscricao
    },
    methods: {
        scrollTo(target, offset = 0) {
            const element = document.querySelector(target)
            if (element) {
                window.scrollTo({
                    top: element.offsetTop - offset,
                    left: 0,
                    behavior: 'smooth'
                })
            }
        }
    },
}
</script>

<style lang="stylus" scoped src="./Ead40.styl"></style>